"use strict";

/**
 * Basis-Entrypoint, registriert die verschiedenen Module auf der Seite
 */

/* Fehler-Logging */
if ( typeof window.Raven !== "undefined" ) {
  Raven.setTagsContext({ app: "bootstrap" });
  /* The magic variable will be replaced by the build system with a real hash */
  if ( '__RELEASE__CONTEXT__' !== (function() { return '__RELEASE_' + '_CONTEXT__'})() ) {
    Raven.setReleaseContext('__RELEASE__CONTEXT__');
    window.Tramino.ReservaAppRelease = '__RELEASE__CONTEXT__';
  } else {
    Raven.setReleaseContext('staging');
    window.Tramino.ReservaAppRelease = 'staging';
  }

  /* Make sure window.Tramino exists */
  if ( typeof window.Tramino === "undefined" ) {
    var err = new Error("Missing window.Tramino");
    Raven.captureException(err);
    throw err;
  }
}

/* Im Backend haben wir standardmäßg keine Sprache */
if ( !window.Tramino.lang ) {
  window.Tramino.lang = "de";
}

/* Schrottige Browser fixen, muss weit oben stehen */
require('reserva/polyfill');

/* Module fürs Init */
var $ = require('jquery');
window._ = require('underscore');

/* Alte Browser komplett blocken um Sentry-Fehler zu vermeiden */
var old_ua = false;
var ua = navigator.userAgent;

if ( ua.indexOf('BingPreview') !== -1 ) {
  old_ua = "Dieser Browser ist nicht unterstützt.";
}
if ( ua.indexOf('MSIE 8.0') !== -1 ) {
  old_ua = "Der Internet Explorer 8.0 wird nicht mehr von Microsoft unterstützt. Bitte aktualisieren Sie diesen oder installieren Sie Firefox/Chrome auf Ihrem PC.";
}

/* Eingeloggte User haben immer ein Recht auf Schmerz */
if ( Tramino.user ) old_ua = false;


var IBE_compat = false;
if ( typeof window.InitIBEGlobal !== "undefined" ) {
  console.log("[Reserva] Running in IBE-compat mode");
  IBE_compat = true;
}

if ( !old_ua ) {

  /* Exportierte Module */
  if ( typeof window.moment === "undefined" ) {
    window.moment = require('moment');
  }

  if ( !IBE_compat ) { // Prevent name clash with old IBE
    window.ReservaApp = require('reserva/engine/main.js');
  }
  window.BrowserApp = require('reserva/browser/main.js');
  window.TraminoCollectible = require('collectible/main.js');
  window.TraminoSiteSearch = require('sitesearch/main.js');
  window.Translator = require('translate').singleton;
  window.ScrollSpy = require('scrollspy/main.js');
  window.MiniEngine = require('reserva/miniengine/main.js');
  window.ClientRatings = require('reserva/miniengine/ratings.js');
  window.TraminoClientsMap = require('reserva/TraminoClientsMap');
  window.SafeStorage = require('storage/SafeStorage');
  window.PriceTable = require('reserva/pricetable');
  window.ReservaInterestFilter = require('reserva/interest-filter.js');

  //window.DateDisplaySingle = require('./display-test/main');
  require('./display-test/style.less');

  window.__ = window.Translator.get;
  window._P = window.Translator.plural;

  /* Analytics */
  var TraminoAnalytics = require('analytics/main.js');
  window.TraminoAnalytics = new TraminoAnalytics($);

  /* Storage täglich leeren um Probleme zu vermeiden */
  if ( !IBE_compat ) {
    var DateTime = require('DateTime');
    var lastClear = SafeStorage.local.get("LastClear");
    var midnight = DateTime.resetTimeFields(new Date);

    if ( !lastClear || parseInt(lastClear, 10) < midnight ) {
      SafeStorage.local.clear();
      SafeStorage.local.set("LastClear", +(new Date));
    }
  }


  /* Zusätzliche Referenzen für Entwickler */
  window.TemplateCache = require('TemplateCache');

  if ( typeof window.Backbone === "undefined" ) {
    window.Backbone = require('backbone');
  }

  window.ReservaRegistry = require('registry');
  ReservaRegistry.setAll(require('./reserva-config.js'));

  /* Templates laden */
  require('reserva/templates/main').register();

  /* Übersetzer in allen Templates verfügbar machen */
  var TemplateCache = require('TemplateCache');
  Translator.registerHelpers(TemplateCache);
  Translator.learn("de", require('reserva/translate/lang.de.js'));
  Translator.learn("en", require('reserva/translate/lang.en.js'));
  Translator.learn("fr", require('reserva/translate/lang.fr.js'));

  TemplateCache.helper("registry", (key) => window.ReservaRegistry.get(key));
  TemplateCache.helper("Customer", window.ReservaRegistry.get("Customer"));

  /* Fix for development */
  if ( Tramino.lang === "no" ) {
      Tramino.lang = "de";
  }

  /* Standardsprache für den Übersetzer */
  Translator.setLanguage(Tramino.lang);

  /* Und für Zeitangaben */
  let locale = window.Tramino.lang;
  if ( !locale ) locale = "de";
  if ( locale === "en" ) locale = "en-gb";
  let active_locale = moment.locale(locale);
  if ( locale !== active_locale ) {
    console.log(`Reserva locale: expect (${locale}) got (${active_locale})`);
  }

  $(document).ready(function() {
      /* Scrollspy Modul */
      ScrollSpy.init();

      /* Analytics */
      $('div.analytics_static').each(function() {
          var data = $(this).data();
          if ( data.page && data.betrieb && data.type ) {
              window.TraminoAnalytics.page = parseInt(data.page, 10);
              window.TraminoAnalytics.send(parseInt(data.betrieb, 10), data.type, true);
          } else {
              var e = new Error("[TA] Found .analytics_static node but missing data-page, data-betrieb or data-type");
              if ( typeof window.Raven !== "undefined" ) {
                Raven.captureException(e);
              } else {
                throw e;
              }
          }
      });

      /* SiteSearch */
      require('sitesearch/page')();
  });
} else {
  if ( window.console && console.log ) window['con' + 'sole'].log("Browser is marked as non-compatible, ignoring it");

  $(document).ready(function() {
    /* Falls wir in der vollen Gastgebersuche sind, zeigen wir unsere Warnung an */
    var container = $('.ibe-container #tab-list');
    if ( container.length ) {
      container.html("<p><b>Ihr Webbrowser ist veraltet und kann von uns leider nicht mehr unterstützt werden:</b><br><br>" + old_ua + "</p>");
    }

    /* Sonstige Buttons besser anzeigen */
    $('#reserva_datepicker_display').text("Nicht unterstützt");
    $('#reserva_people_display').text("Nicht unterstützt");
  });
}



// WEBPACK FOOTER //
// ./main.js